import React, { Component } from 'react';
import AiOptionWrap from "./AiOptionWrap";
import AiInputWrap from "./AiInputWrap";
import AiInputWrapDia from "./AiInputWrapDia";
import AiReviewWrap from './AiReviewWrap';
import { SPECIAL_NOTE_SMALL,SPECIAL_NOTE_SMALL_PPL } from '../constants';
import { SPECIAL_NOTE_ACTIVATE } from '../constants';
//import { SPECIAL_NOTE_SMALL2 } from '../constants';
//import { SPECIAL_NOTE_LINK } from '../constants';

var orientation = ''

export function scrollToOption(option) {
  if (option == 'rs') {
    var element = document.getElementsByClassName('ai-name-size')[0]}
  else {
    var element = document.getElementById(option)}
  var rect = element.getBoundingClientRect();
  var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  var offset = parseInt(rect.height, 10) / 2 - windowHeight / 2;
  if (orientation === 'portrait')
    offset -= 295/2;
  var top = 0;
  
  do {
      top += parseInt(element.offsetTop, 10) || 0;
      element = element.offsetParent;
  } while(element);

  let y = top + offset;
  if ((getLowerBound() < y) || ((getLowerBound() - y) <= 15))
    y = getLowerBound();

  /* console.log('default', 'window.scrollTo(0, ' + (top + offset).toFixed(0) + ');')
  console.log('bounds', 'window.scrollTo(0, ' + getLowerBound().toFixed(0) + ');') */
  
  window.scrollTo({ top: y.toFixed(0), left: 0, behavior: 'smooth'});
}

function getLowerBound() {
  var element;
  var offset;
  if (orientation !== 'portrait') {
    element = document.querySelector('.ai-right-panel')
    offset = 5;
  }
  else {
    element = document.querySelector('.ai-main-body')
    offset = 15;
  }

  var rect = element.getBoundingClientRect();
  var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  var top = 0;

  do {
      top += parseInt(element.offsetTop, 10) || 0;
      element = element.offsetParent;
  } while(element);
  
  return top + parseInt(rect.height, 10) - windowHeight + offset;
}

//import {Accordion} from 'primereact/components/accordion/Accordion';
//import {AccordionTab} from 'primereact/components/accordion/Accordion';


class AiOptionSet extends Component {
  
  constructor(props) {
      super(props);
      orientation = this.props.orientation;
  }
  componentDidUpdate() {
    if (orientation !== this.props.orientation && this.props.orientation !== undefined) {
      orientation = this.props.orientation;
    }
  }
//test
  render() {
    ////console.log('get all options',this.props.options);
    var rows = [];
    //var bandrows = [];
    var last =0 
    var cur_option
    if (this.props.options['options_all'] !== undefined) {
      last = this.props.options['options_all'].length -1
    }  
    for (let i in this.props.options['options_all']) {
      cur_option= this.props.options['options_all'][i]
      ////console.log('last value',cur_option,parseInt(i,10),last, this.props.single_sc_option)
      var lastValue ='false'
      if (parseInt(i,10)===last || (cur_option === "sc" && this.props.single_sc_option )) {
        lastValue = 'true' 
        ////console.log('let lastValue be TRUE')
      } 

      var cur_details= this.props.options['options_' + cur_option]
      var cur_details_options= []
      for (let i1 in cur_details.options)
      {
         //console.log('let lastValue be TRUE',cur_details.options[i1])
        if (cur_details.options[i1].hasOwnProperty('show')===false || cur_details.options[i1]['show']===true){
        // console.log('PUSHED',cur_details.options[i1].name)
        cur_details_options.push(cur_details.options[i1])
        }
      }

      
      ////console.log('cur_option',cur_option,this.props.options)
      var cur_name = cur_details.name
      if (cur_details.option_name === 'stone') {
        cur_name = "Stone"
        
      }
      var cur_value = this.props.options['value_' + cur_option]
      var band_attrs=["band","bset","bsetc","bsetl","ben","bmet","bmetc","eb1"]
      
      var red_note ='' 
      if (SPECIAL_NOTE_ACTIVATE){
         red_note =SPECIAL_NOTE_SMALL
         if (window.currentSite === 'peoplesjewellers') 
            red_note =SPECIAL_NOTE_SMALL_PPL
      }
      //var red_note =SPECIAL_NOTE_SMALL
      //var red_note1=''
      //var red_note2=''
      //var red_link=''
      ////console.log('SITES',this.props.site)
      /*if (this.props.site === 'kay'){
        red_note1 =NOTE_SMALL1
        red_note2 =SPECIAL_NOTE_SMALL2
        red_link =<a href={SPECIAL_NOTE_LINK}>click here</a> 
      }*/
      var option_name =
       this.props.options['options_' + cur_option].option_name !== undefined ? ' ai-name-'+this.props.options['options_' + cur_option].option_name: ''
   // console.log('this.props.option_name',cur_details,cur_details_options)
    var maxSliderSize = (this.props.optionNumber * this.props.optionSize + 60) +'px';
    var maxSliderSizeNum = this.props.optionNumber * this.props.optionSize 
      if (cur_details.show)
       switch (cur_details.type) {
      
        case 'select':
        case 'control':
          ////console.log('AIOptions',this.props)

          if (band_attrs.indexOf(cur_option) === -1) 
          {
           rows.push(<AiOptionWrap
            key={cur_option} 
            name={cur_name} 
            attr={cur_option}
            ce={this.props.ce}
            css={cur_details.css}
            ds ={this.props.ds}
            dctw ={this.props.dctw}
            head ={this.props.head}
            bandC ={this.props.bandC}
            bandS ={this.props.bandS}
            sh ={this.props.sh}
            children={cur_details_options} 
            optionNumber={this.props.optionNumber} 
            optionSize={this.props.optionSize}
            optionName={option_name}
            initialValue={cur_value}
            image_base={cur_details.image_base}
            image_postfix={cur_details.image_postfix}
            last= {lastValue}
            options_all={this.props.options_all}
            orientation={this.props.orientation}/>);
            if (cur_option ==='ce' && cur_value ==='LD')
            rows.push(<div className="ai-lcd" key="lgd_option" >Lab Grown Diamond Quality - F/VS2 for center and side stones</div>)
          }
           else
           {
            rows.push(<AiOptionWrap
              key={cur_option} 
              name={cur_name} 
              attr={cur_option}
              ce={this.props.ce}
              css={cur_details.css}
              ds ={this.props.ds}
              dctw ={this.props.dctw}
              head ={this.props.head}
              sh ={this.props.sh}
              children={cur_details_options} 
              optionNumber={this.props.optionNumber} 
              optionSize={this.props.optionSize}
              optionName={option_name}
              initialValue={cur_value}
              image_base={cur_details.image_base}
              image_postfix={cur_details.image_postfix}
              last= {lastValue}
              options_all={this.props.options_all}
              orientation={this.props.orientation}/>);
            }
              break;
        case 'inputDia':
              if (band_attrs.indexOf(cur_option) === -1) 
                rows.push(<AiInputWrapDia
                  key={cur_option} 
                  name={cur_details.name} 
                  children={cur_details.options} 
                  
                  />);
                  break;

        case 'input':
        if (band_attrs.indexOf(cur_option) === -1) 
          rows.push(<AiInputWrap 
            key={cur_option} 
            name={cur_details.name} 
            product='ring'
            maxSliderSize ={maxSliderSizeNum}
            children={cur_details.options} 
            options_all={this.props.options_all}
           
            
        //    optionNumber={this.props.optionNumber} 
        //    optionSize={this.props.optionSize}
            />);
            else
            rows.push(<AiInputWrap 
                key={cur_option} 
                name={cur_details.name} 
                maxSliderSize ={maxSliderSizeNum}
                product='band'
                children={cur_details.options} 
                options_all={this.props.options_all}
                />);
               
            break;
        default:
            break;
        
      }
      
    }
    var addesa=''
    var esaval=''
    var esadetail=[]
    var i
    var addesa2='' 
    var addesa4='' 
    //console.log('esa from state',this.props.esa,this.props.price1)    
    if (this.props.esa !== undefined)
    {
    for (i in   this.props.esa) {
      if (parseFloat(this.props.price1) >= this.props.esa[i][0] && parseFloat(this.props.price1) <= this.props.esa[i][1]) {
      //console.log( 'i',this.props.esa[i])
      esaval=this.props.esa[i][2]
      }
    }
    for (i in this.props.esadetail)
    if (this.props.esadetail[i][0] === 'Ring Sizing')
    {
     esadetail.push(<tr><td className="ai-esa-th"><b>{this.props.esadetail[i][0]}<sup>4</sup></b></td><td key={"td1"+i.toString} className="ai-esa-th">{this.props.esadetail[i][1]}</td><td className="ai-esa-th">INCLUDED</td></tr>)
     addesa4=<p id="ringDisc" styleName="ai-esa-padding">
      <sup>4</sup>Allow ring sizing up or down two sizes.
    </p>
    }
     else if (this.props.esadetail[i][0] === 'Free One-Time Engraving'){
     esadetail.push(<tr><td className="ai-esa-th"><b>{this.props.esadetail[i][0]}<sup>2</sup></b></td><td key={"td2"+i.toString}className="ai-esa-th">{this.props.esadetail[i][1]}</td><td className="ai-esa-th">INCLUDED</td></tr>)
     addesa2=<sup>1,2</sup> 
     }
     else 
        esadetail.push(<tr><td className="ai-esa-th"><b>{this.props.esadetail[i][0]}</b></td><td  key={"td3"+i.toString} className="ai-esa-th">{this.props.esadetail[i][1]}</td><td className="ai-esa-th">INCLUDED</td></tr>)
    addesa=
    <div>
    <div className="ai-esa-icon">
              <input type="checkbox" id="addToCartPlanSub"  onClick={(e)=>this.props.onESA(e.currentTarget.checked)}/>
          
              <img className='ai-esa-img' alt='ESA' width='18px' height='18px' src="//static.thepersonalizedbest.com/pers4/esaIcon.svg"></img>
              <div className="ai-chat-text">
                             <p>Protect Your Jewelry For Life<sup>1</sup> for ${esaval}</p>
                             <p className='ai-esa-font'> Enjoy lifetime service with a one-time purchase</p>
              </div> 
      
    </div>
    <div className="ai-esa-block">
    <table className="ai-esa-table">
                   <thead  className={"ai-esa-thead-"+  window.currentSite}>
        <tr>
          <th className="ai-esa-th" key="th1">Service Needed</th>
          <th className="ai-esa-th" key="th2">Typical Cost<sup>5</sup></th>
          <th className="ai-esa-th" key="th3">With This Plan</th>
        </tr>
      </thead><tbody>
      {esadetail}
      </tbody>
                   </table>
        
    </div>
    <div className="ai-esa-th">
  <a href={window.baseSiteUrl+"/forever-cherished-lifetime-protection-plan"}  target="_blank">Learn more</a>
  </div>
  
  <span className="ai-esa-discl">
  <div className="ai-esa-padding">
    <sup>1</sup>
      Excludes repair and replacement of diamonds and gemstones. 
    
      {addesa2}
      Other limitations apply. By purchasing, I agree to&nbsp;
    <u>
      <a target="_blank" href={window.baseSiteUrl+"/forever-cherished-lifetime-protection-plan-details"}>Plan Terms and Electronic Delivery.</a>
    </u>
    {addesa4}
    <p id="costDisc" className="ai-esa-padding">
      <sup>5</sup>Costs may vary depending on specific service, size and material type.
    </p>
  </div></span>
    </div>
    }
    
    var addchat=''
    //<!--div key="patent1" className="separator2"><p>
    //{addchat}  </p></div-->
    //      if (h>w)
              addchat= 
              <div className="ai-chat-block">
              <div className="ai-chat-icon">
                                     <img alt='chat' width='45px' height='45px' src="//static.thepersonalizedbest.com/pers4/chat.jpg"></img>
              </div>
              <div className="ai-chat-text">
                             <p>Have a question about {this.props.title}?</p>
                             <p><a href="javascript:document.getElementsByClassName('LPMcontainer')[0].click();" >Chat Now</a></p>
              </div>
              </div> 
    return (
      <div className='ai-option-wrap' style={{width:maxSliderSize}}>
      {rows}
     
      <AiReviewWrap/>

      <div className='ai-special-note'><font color='red'>{red_note}</font></div>
      {/*<div className='ai-bottom'/>*/}
      <div key="patent" className="separator2a">&nbsp;&nbsp;</div>
      
    <p></p>
    {addesa}   
    {addchat} <p/>
     <div key="patent2" className="separator2">&nbsp;Patent Pending Technology&nbsp;</div><p></p>
     </div>
    );
  }
}
export default AiOptionSet;